import { useQuery } from "@tanstack/react-query";
import { api } from "./client";

/** A jogi dokumentumok linkjei (`legal.*` settings). Lehetnek relatív útvonalak is —
 *  tipikusan egy saját, admin által szerkesztett oldalra mutatnak (`/aszf`). */
export interface LegalLinks {
  terms_url: string;
  privacy_url: string;
}

/** Amíg a válasz megjön (vagy ha nem érhető el), a konvencionális útvonalakat használjuk. */
export const LEGAL_FALLBACK: LegalLinks = {
  terms_url: "/aszf",
  privacy_url: "/adatkezeles",
};

export function useLegalLinks(): LegalLinks {
  const { data } = useQuery({
    queryKey: ["site", "legal"],
    queryFn: () => api<LegalLinks>("/site/legal"),
    staleTime: 10 * 60 * 1000,
  });
  return data ?? LEGAL_FALLBACK;
}
